var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedHorizontalStrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67.69 16.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Garnet);}.cls-15,.cls-2{opacity:0.35;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#Carrot);}.cls-19,.cls-20,.cls-21,.cls-29,.cls-30,.cls-6,.cls-7,.cls-8{opacity:0.59;}.cls-6{fill:url(#Carrot-2);}.cls-7{fill:url(#Carrot-3);}.cls-8{fill:url(#Carrot-4);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13,.cls-25,.cls-32{opacity:0.5;}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#Garnet-2);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:url(#Carrot-5);}.cls-19{fill:url(#Carrot-6);}.cls-20{fill:url(#Carrot-7);}.cls-21{fill:url(#Carrot-8);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:url(#Garnet-3);}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#Carrot-9);}.cls-29{fill:url(#Carrot-10);}.cls-30{fill:url(#Carrot-11);}.cls-31{fill:#b55e47;}.cls-32{fill:url(#linear-gradient-16);}.cls-33{fill:url(#linear-gradient-17);}.cls-34{fill:url(#linear-gradient-18);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Garnet",
    x1: 1463.95,
    y1: -1448.35,
    x2: 1479.96,
    y2: -1448.35,
    gradientTransform: "matrix(0, 1, 1, 0, 1459.07, -1463.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#961c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b0605d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9a4c4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#7b3031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#681f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61191b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1479.35,
    y1: -1435.29,
    x2: 1479.35,
    y2: -1457.73,
    gradientTransform: "matrix(0, 1, 1, 0, 1459.07, -1463.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fdcfb0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcfaf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1464.52,
    y1: -1443.78,
    x2: 1479.74,
    y2: -1459,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1464.61,
    y1: -1433.51,
    x2: 1464.61,
    y2: -1443.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot",
    x1: 6.37,
    y1: 7.97,
    x2: 21.44,
    y2: 7.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c2671d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d37a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d77e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#e7863a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f28b3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f68d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f68e3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f59143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f49750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f39f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f2a56e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f49a56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f68d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ed8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ee8b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ef944d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f2a269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f2a56e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f9bd85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdca92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-2",
    x1: 1466.55,
    y1: -1440.12,
    x2: 1467.58,
    y2: -1440.12,
    gradientTransform: "matrix(0, 1, 1, 0, 1459.07, -1463.95)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-3",
    x1: 1395.18,
    y1: 558.71,
    x2: 1395.98,
    y2: 558.71,
    gradientTransform: "matrix(-0.72, -0.69, -0.69, 0.72, 1407.13, 567.32)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-4",
    x1: 1476.2,
    y1: -1445.17,
    x2: 1477.38,
    y2: -1445.17,
    gradientTransform: "matrix(0, 1, 1, 0, 1459.07, -1463.95)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1988.15,
    y1: -649.19,
    x2: 1988.15,
    y2: -650.52,
    gradientTransform: "translate(2003.38 -638.3) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 27.03,
    y1: 5.98,
    x2: 27.03,
    y2: 4.64,
    gradientTransform: "translate(-7.77 -0.93)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1472.92,
    y1: -1496,
    x2: 1471.8,
    y2: -1497.12,
    gradientTransform: "matrix(0, 1, 1, 0, 1510.05, -1463.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 11.91,
    y1: 13.41,
    x2: 11.91,
    y2: 14.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdcfaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcfb0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Garnet-2",
    x1: 1463.95,
    y1: 546.66,
    x2: 1479.96,
    y2: 546.66,
    gradientTransform: "translate(603.63 -1463.95) rotate(90)",
    xlinkHref: "#Garnet"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1479.38,
    y1: 560.26,
    x2: 1479.38,
    y2: 538.82,
    gradientTransform: "translate(603.63 -1463.95) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1464.52,
    y1: 551.23,
    x2: 1479.74,
    y2: 536.01,
    gradientTransform: "translate(603.63 -1463.95) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1464.64,
    y1: 561.8,
    x2: 1464.64,
    y2: 551.29,
    gradientTransform: "translate(603.63 -1463.95) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-5",
    x1: 46.25,
    y1: 7.97,
    x2: 61.32,
    y2: 7.97,
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-6",
    x1: 1466.5,
    y1: 554.89,
    x2: 1467.68,
    y2: 554.89,
    gradientTransform: "translate(603.63 -1463.95) rotate(90)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-7",
    x1: -48.31,
    y1: -818.4,
    x2: -47.5,
    y2: -818.4,
    gradientTransform: "translate(655.58 567.32) rotate(-43.65)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-8",
    x1: 1476.23,
    y1: 549.85,
    x2: 1477.38,
    y2: 549.85,
    gradientTransform: "translate(603.63 -1463.95) rotate(90)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -57.87,
    y1: -649.14,
    x2: -57.87,
    y2: -650.52,
    gradientTransform: "matrix(1, 0, 0, -1, 110.34, -638.26)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2072.98,
    y1: 6.04,
    x2: 2072.98,
    y2: 4.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 2121.42, -0.97)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1473.05,
    y1: 550.09,
    x2: 1471.83,
    y2: 548.87,
    gradientTransform: "translate(603.63 -1463.95) rotate(90)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 3545.86,
    y1: 13.41,
    x2: 3545.86,
    y2: 14.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 3601.63, 0)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Garnet-3",
    x1: 33.75,
    y1: 0,
    x2: 33.75,
    y2: 16.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Garnet"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 33.75,
    y1: 2.52,
    x2: 33.75,
    y2: 1.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e332f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c2826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-9",
    x1: 46.42,
    y1: 7.97,
    x2: 21.08,
    y2: 7.97,
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-10",
    x1: 1476.21,
    y1: -1425.34,
    x2: 1477.4,
    y2: -1425.34,
    gradientTransform: "matrix(0, 1, 1, 0, 1459.07, -1463.95)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Carrot-11",
    x1: 1466.51,
    y1: -1425.34,
    x2: 1467.61,
    y2: -1425.34,
    gradientTransform: "matrix(0, 1, 1, 0, 1459.07, -1463.95)",
    xlinkHref: "#Carrot"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 33.75,
    y1: 13.41,
    x2: 33.75,
    y2: 14.81,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 41.52,
    y1: 5.98,
    x2: 41.52,
    y2: 4.64,
    gradientTransform: "translate(-7.77 -0.93)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 41.49,
    y1: -915.84,
    x2: 41.49,
    y2: -917.22,
    gradientTransform: "matrix(1, 0, 0, -1, -7.74, -904.96)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atk_Def_Panel",
    "data-name": "Atk/Def Panel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left_Frame",
    "data-name": "Left Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M21.44,0H14.72a.43.43,0,0,0-.32.14L.12,15.26A.45.45,0,0,0,.45,16h21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M.74,16a1.2,1.2,0,0,1-.49,0,1,1,0,0,1-.18-.19l2.32-1H21.44V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M2.39,14.81,15.44,1.35,14.72,0s-.2,0-.26.07c-.27.31-.61.65-.61.65L.67,14.68a4.25,4.25,0,0,0-.6.66.39.39,0,0,0,0,.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "15.44 1.35 14.72 0 21.44 0 21.44 1.35 15.44 1.35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "21.44 2.52 16.47 2.54 6.37 13.41 21.44 13.41 21.44 2.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "21.44 3.71 17.07 3.71 16.47 2.54 21.44 2.52 21.44 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "6.37 13.41 16.47 2.53 17.07 3.71 9.02 12.23 6.37 13.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "21.44 12.23 9.02 12.23 6.37 13.41 21.44 13.41 21.44 12.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "21.44 12.23 9.02 12.23 17.07 3.72 21.44 3.71 21.44 12.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "12.13 10.89 21.44 10.89 21.44 12.23 9.02 12.23 12.13 10.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "21.44 5.05 17.86 5.05 17.07 3.71 21.44 3.71 21.44 5.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "9.02 12.23 17.07 3.71 17.86 5.05 12.13 10.89 9.02 12.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2.39 14.81 6.42 13.41 21.43 13.41 21.44 14.81 2.39 14.81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right_Frame",
    "data-name": "Right Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-14",
    d: "M46.25,0H53a.45.45,0,0,1,.33.14L67.57,15.26a.44.44,0,0,1-.32.75h-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-15",
    d: "M67,16a1.21,1.21,0,0,0,.5,0,1.42,1.42,0,0,0,.18-.19l-2.32-1H46.25V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-16",
    d: "M65.31,14.81,52.26,1.34,53,0s.21,0,.26.07c.27.31.61.65.61.65L67,14.68a4.25,4.25,0,0,1,.6.66.39.39,0,0,1,0,.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-17",
    points: "52.26 1.34 52.97 0 46.25 0 46.25 1.34 52.26 1.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-18",
    points: "46.25 2.52 51.23 2.54 61.32 13.41 46.25 13.41 46.25 2.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-19",
    points: "46.25 2.52 51.23 2.54 50.63 3.74 46.25 3.74 46.25 2.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-20",
    points: "61.32 13.41 51.23 2.53 50.62 3.73 58.67 12.26 61.32 13.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-21",
    points: "46.25 12.26 58.67 12.26 61.32 13.41 46.25 13.41 46.25 12.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "46.25 12.26 58.67 12.26 50.63 3.75 46.25 3.74 46.25 12.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-22",
    points: "55.34 10.9 46.25 10.88 46.25 12.26 58.67 12.26 55.34 10.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-23",
    points: "46.25 5.08 49.84 5.08 50.63 3.74 46.25 3.74 46.25 5.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "58.67 12.26 50.63 3.74 49.84 5.08 55.34 10.9 58.67 12.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "65.3 14.81 61.27 13.41 46.26 13.41 46.25 14.81 65.3 14.81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 21.08,
    width: 25.34,
    height: 16.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 21.08,
    y: 1.35,
    width: 25.34,
    height: 1.18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M21.09,13.41H46.42m0-10.89H21.08M46.42,13.41V12.26L29,12.23H21.08v1.18M46.42,3.74V2.52H21.08V3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-29",
    points: "46.42 13.41 21.08 13.41 21.08 12.23 46.42 12.26 46.42 13.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-30",
    points: "46.42 3.74 21.08 3.71 21.08 2.52 46.42 2.52 46.42 3.74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-31",
    x: 33.08,
    y: -11.99,
    width: 1.34,
    height: 25.33,
    transform: "translate(34.43 -33.08) rotate(90)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "21.09 14.81 21.08 13.41 46.42 13.41 46.42 14.81 21.09 14.81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "46.42 12.26 46.42 3.74 21.08 3.71 21.08 12.23 46.42 12.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-33",
    points: "46.42 5.05 21.08 5.05 21.08 3.71 46.42 3.74 46.42 5.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-34",
    points: "46.42 10.88 21.08 10.88 21.08 12.23 46.42 12.26 46.42 10.88"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHorizontalStrip);
export default __webpack_public_path__ + "static/media/redHorizontalStrip.99cce1afafd385a22e7dc514ee4e5e56.svg";
export { ForwardRef as ReactComponent };